"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTruncate = _interopRequireDefault(require("react-truncate"));
var _angieslistReactComponents = require("angieslist-react-components");
var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));
var _truncateWidthsByCardStyle = _interopRequireDefault(require("./utils/truncateWidthsByCardStyle"));
require("./dealCard.scss");
var defaultDealImage = require('../assets/default-deal-img.jpg');
var DealCardHeader = function DealCardHeader(_ref) {
  var children = _ref.children,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    cardStyle = _ref.cardStyle,
    lazyLoadImage = _ref.lazyLoadImage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "acc-dealCard-".concat(cardStyle)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "acc-dealCard"
  }, cardStyle !== 'mini' ? lazyLoadImage ? /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.LazyImage, {
    className: "acc-dealCard-photo",
    alt: title,
    src: imageUrl,
    fallbackImage: defaultDealImage
  }) : /*#__PURE__*/_react["default"].createElement(_reactImageFallback["default"], {
    className: "acc-dealCard-photo",
    alt: title,
    src: imageUrl,
    fallbackImage: defaultDealImage
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "acc-dealCard-dealBody"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "acc-dealCard-title"
  }, /*#__PURE__*/_react["default"].createElement(_reactTruncate["default"], {
    lines: 2,
    width: _truncateWidthsByCardStyle["default"][cardStyle]
  }, title)), children, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "acc-dealCard-divider"
  }), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Button, {
    bsSize: "md",
    bsStyle: "link",
    className: "text-info",
    style: {
      fontWeight: 'bold'
    }
  }, "View Deal Details"))));
};
DealCardHeader.propTypes = {
  cardStyle: _propTypes["default"].string.isRequired,
  imageUrl: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  lazyLoadImage: _propTypes["default"].bool
};
DealCardHeader.defaultProps = {
  imageUrl: '',
  lazyLoadImage: false
};
var _default = exports["default"] = DealCardHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/offers/dealCardHeader.js
// module id = 6379
// module chunks = 25